/* eslint-disable @typescript-eslint/no-explicit-any */
import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { Card, Text, Button, Heading } from "nectar-ui";
import { NectarTheme } from "@nectarTypes";

export const PageCardsContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    row-gap: ${theme.spacings.lg};
    flex-direction: column;
    align-items: center;
    margin-top: ${theme.spacings.xs};

    ${theme.breakpoints.sm} {
      flex-direction: row;
      column-gap: ${theme.spacings.lg};
      width: 90%;
      max-width: 620px;
      flex-wrap: wrap;
      justify-content: center;
    }

    ${theme.breakpoints.xl} {
      max-width: unset;
    }
  `}
`;

export const IconContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    column-gap: ${theme.spacings.xs};
    align-items: center;

    ${theme.breakpoints.sm} {
      flex-direction: column;
      row-gap: ${theme.spacings.xs};
    }
  `}
`;

export const HomeCard = styled(Card)<NectarTheme>`
  ${({ theme }) => css`
    height: 190px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    justify-self: center;
    padding: ${theme.spacings.lg};

    div[data-ui="button"] {
      width: 100%;
      display: flex;
    }

    ${theme.breakpoints.sm} {
      max-width: 290px;
      height: 225px;
      div[data-ui="button"] {
        width: 40%;
        display: flex;
      }
    }
  `}
`;

export const HomeCardText = styled(Text)`
  text-align: center;
  margin-bottom: 0;
  font-size: 16px;
`;

export const HomeCardHeading = styled(Heading)`
  text-align: center;
  margin-bottom: 0;
  letter-spacing: 0;
`;

export const HomeCardButton = styled(Button)`
  width: 100%;
  display: flex;
`;

export const CardTitleContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    column-gap: ${theme.spacings.lg};
  `}
`;
